import { Sentry } from "@/infrastructure/services/logger";
import useLogger from "@/presentation/deduction/hooks/logger/useLogger";
import { Button, EmptyState, Flex, Icons } from "@ir/ui";
import React from "react";

interface ErrorBoundaryProps {
  children: React.ReactNode;
  showDialog?: boolean;
  onError?: (error: unknown, componentStack: string, eventId: string) => void;
  fallback?: React.ReactElement;
}

const ErrorBoundary = ({ children, showDialog = false, onError, fallback }: ErrorBoundaryProps) => {
  const { logger } = useLogger({ componentName: "ErrorBoundary" });

  const fallbackComponent = (
    <Flex direction="column" className="m-auto" justifyContent="center" align="center">
      <EmptyState
        className="bg-white border-1 border-color-grey-25 px-4 py-5 mt-5"
        style={{ minWidth: 600 }}
        icon={Icons.Settings}
        title="Something went wrong"
        description="Please try again later"
      >
        <Button
          onPress={() => {
            globalThis.location.reload();
          }}
        >
          Reload
        </Button>
      </EmptyState>
    </Flex>
  );

  return (
    <Sentry.ErrorBoundary
      showDialog={showDialog}
      onError={
        onError ??
        (error => {
          logger.error("ErrorBoundary error", error);
        })
      }
      fallback={fallback ?? fallbackComponent}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};

export default ErrorBoundary;
